var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHowcanyougetinvolved3X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "How can you get involved") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-/-S2-01-1_Landing_page-1",
    transform: "translate(-1012.000000, -912.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "How-can-you-get-involved",
    transform: "translate(1012.000000, 912.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.52,73.5933333 L101.853333,80.12 C104.972815,81.9230006 106.04113,85.9127718 104.24,89.0333333 L104.24,89.0333333 C102.436999,92.1528147 98.4472282,93.2211304 95.3266667,91.42 L67.0666667,75.1066667",
    id: "Path",
    stroke: "#6551FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6466667,88.1666667 C92.7540674,89.9810551 93.8067575,93.9681561 92,97.08 L92,97.08 C90.1969994,100.199481 86.2072282,101.267797 83.0866667,99.4666667 L60.5066667,86.4133333",
    id: "Path",
    stroke: "#6551FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.646667,69.1666667 C111.754067,70.9810551 112.806757,74.9681561 111,78.08 L111,78.08 C109.196999,81.1994813 105.207228,82.2677971 102.086667,80.4666667 L79.5066667,67.4133333",
    id: "Path",
    stroke: "#6551FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4666667,96.2066667 C80.586148,98.0096672 81.6544637,101.999438 79.8533333,105.12 L79.8533333,105.12 C78.0503328,108.239481 74.0605615,109.307797 70.94,107.506667 L70.1866667,107.073333 L26.48,81.84 L25.7266667,81.4066667 C19.7284822,77.9454111 15.3512951,72.2427632 13.5583689,65.5536733 C11.7654428,58.8645835 12.7037012,51.7371974 16.1666667,45.74 L22.6933333,34.4066667 C29.9123705,21.9319982 45.874837,17.6675815 58.3533333,24.88 L60.6266667,26.2133333",
    id: "Path",
    stroke: "#6551FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.346667,68.82 L109.16,67.4066667 C116.367941,54.9211893 112.091011,38.9565703 99.6066667,31.7466667 L88.2733333,25.22 C75.7997652,18.0483171 59.8750607,22.3209442 52.6666667,34.7733333 L35.0866667,64 L39.7533333,65.7533333 C42.5873314,66.8170062 45.7789767,66.1900298 48,64.1333333 L59.28,51.9 C67.0333333,55.2 72.34,53.06 76.7066667,50.5666667",
    id: "Path",
    stroke: "#F64142",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 128,
    height: 128
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.815673,
    y1: 67.8584913,
    x2: 76.5634398,
    y2: 51.5068641,
    id: "Path",
    stroke: "#F64142",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(92.689556, 59.682678) scale(1, -1) rotate(-58.000000) translate(-92.689556, -59.682678) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowcanyougetinvolved3X);
export default __webpack_public_path__ + "static/media/How can you get involved@3x.1239954554cfca05a0af620018f7e8ed.svg";
export { ForwardRef as ReactComponent };